import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ExpoTheme } from "./themes/ExpoTheme";
import ExpoPlannerBuilder from "./ExpoPlannerBuilder";
import RegistrationForm from "./formbuilder/RegistrationForm";
import "react-quill/dist/quill.snow.css";
import AddProductCategories from "./formbuilder/AddProductCategories";
import ChooseCategoryOptions from "./pages/ChooseCategoryOptions";
import RegTemplates from "./formbuilder/templates/RegTemplates";
import TemplateSettings from "./formbuilder/templates/TemplateSettings";
import RegFormContainer from "./formbuilder/container/RegFormContainer";
import ProductCategoriesView from "./pages/ProductCategoriesView";
import EmailTemplate from "./formbuilder/templates/EmailTemplate";
import ResgistrationConfirmation from "./pages/ResgistrationConfirmation";
import TermsConditions from "./formbuilder/templates/TermsConditions";
import GtagLoader from "./gtag/GtagLoader";
import GtagRouterTracker from "./gtag/GtagRouterTracker";
import OpenStudentRegistration from "./pages/StudentRegistration";
const queryClient = new QueryClient();
const App = () => {
  // return (
  //   <Container maxWidth="sm" sx={{ my: 3 }}>
  //     <Alert severity="info">
  //       The time preiod for editing this form is over. Please use the settings
  //       in the Management Panel to customize available options
  //     </Alert>
  //   </Container>
  // );
  return (
    <>
      <GtagLoader />
      <ThemeProvider theme={ExpoTheme}>
        <QueryClientProvider client={queryClient}>
          <Fragment>
            <BrowserRouter>
              <GtagRouterTracker />
              <ToastContainer autoClose={1500} />
              <Routes>
                <Route path="/" element={<ExpoPlannerBuilder />} />
                <Route
                  path="/reg-form-builder/:id"
                  element={<RegistrationForm />}
                />
                <Route path="/reg-template/:id" element={<RegTemplates />} />
                <Route
                  path="/template-settings/:id"
                  element={<TemplateSettings />}
                />
                <Route
                  path="/add-product-categories/:cat/:id"
                  element={<AddProductCategories />}
                />
                <Route
                  path="/add-product-categories/:cat/:type/:id"
                  element={<AddProductCategories />}
                />
                <Route
                  path="/choose-category-options/:id"
                  element={<ChooseCategoryOptions />}
                />
                <Route
                  path="/product-categories-view/:id"
                  element={<ProductCategoriesView />}
                />

                <Route
                  path="/reg-email-template-editor/:id"
                  element={<EmailTemplate />}
                />

                <Route
                  path="/student-registration"
                  element={<OpenStudentRegistration />}
                />
                <Route
                  path="/visitor-registration"
                  element={<RegFormContainer />}
                />
                <Route
                  path="/registration-confirmation/:id"
                  element={<ResgistrationConfirmation />}
                />
                <Route path="/terms-conditions" element={<TermsConditions />} />
              </Routes>
            </BrowserRouter>
          </Fragment>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
